import styled from "styled-components"
import DarkVideo from "../../assets/video/contact-banner-horizontal.mp4"
import LightVideo from "../../assets/video/band-white-horizontal.mp4"
import React, { useMemo } from "react"
import { getIdWithoutSpecialSymbols, getPropSafely } from "@repo/utils"
import Text3DBanner from "./Text3DBanner"
import useVisible3D from "../../hooks/useVisible3D"
import Video from "../WebGL/Video/Video"
import DescriptionSlogan from "../common/DescriptionSlogan"

const Container = styled.div`
	position: relative;
`

const BannerHeaderContainer = styled.div`
	min-height: calc(var(--custom-lvh, 100vh) * 101);
`

const Banner = styled(Text3DBanner)`
	.video {
		position: absolute !important;
		inset: 0;
		z-index: 0;
	}
`

const VideoBanner = ({ data, webGL = false }) => {
	const { banner, video = true } = data
	const id = getIdWithoutSpecialSymbols(data?.id)
	const src = useMemo(() => {
		return banner?.variant === "light" ? LightVideo : DarkVideo
	}, [banner])
	const visible3D = useVisible3D(webGL && video)

	const withDescription = getPropSafely(data, "withDescription", false, { silent: true })
	const description = getPropSafely(data, "description", {}, { silent: true })

	const poster = banner?.variant === "light" ? "/images/band-white-poster.webp" : "/images/contact-banner-poster.webp"

	return (
		<Container className={withDescription ? "with-description" : ""}>
			<BannerHeaderContainer>
				<Banner data={banner} webGL={visible3D && webGL}>
					{video && (
						<Video
							key={id}
							id={`video-banner-${id}`}
							src={src}
							autoplay
							webGL={visible3D && webGL}
							preload="metadata"
							priority
							poster={poster}
							loadWhenNear={false}
						/>
					)}
				</Banner>
			</BannerHeaderContainer>
			{withDescription && <DescriptionSlogan data={description} />}
		</Container>
	)
}

export default VideoBanner
